import { Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Buttons, RaisedButton } from "../../../Constant";
import RaisedDefaultButtons from "./DefaultButtons";
import RaisedLargeButtons from "./LargeButtons";
import RaisedSmallButtons from "./SmallButtons";
import RaisedExtraSmallButtons from "./ExtraSmallButtons";
import RaisedActiveButtons from "./ActiveButtons";
import RaisedDisabledButtons from "./DisabledButtons";
import RaisedCustomStateButtons from "./CustomStateButtons";
import RaisedOutlineButtons from "./OutlineButtons";
import RaisedBoldBorderOutlineButtons from "./BoldBorderOutlineButtons";
import RaisedOutlineLargeButtons from "./OutlineLargeButtons";
import RaisedOutlineSmallButtons from "./OutlineSmallButtons";
import RaisedOutlineExtraSmallButtons from "./OutlineExtraSmallButtons";
import RaisedDisabledOutlineButtons from "./DisabledOutlineButtons";
import RaisedGradienButtons from "./GradienButtons";

const RaisedStyleContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={RaisedButton} parent={Buttons} title={RaisedButton} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <RaisedDefaultButtons />
            <RaisedLargeButtons />
            <RaisedSmallButtons />
            <RaisedExtraSmallButtons/>
            <RaisedActiveButtons/>
            <RaisedDisabledButtons/>
            <RaisedCustomStateButtons/>
            <RaisedOutlineButtons/>
            <RaisedBoldBorderOutlineButtons/>
            <RaisedOutlineLargeButtons/>
            <RaisedOutlineSmallButtons/>
            <RaisedOutlineExtraSmallButtons/>
            <RaisedDisabledOutlineButtons/>
            <RaisedGradienButtons/>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default RaisedStyleContainer;
